module.exports = __webpack_public_path__ + "static/media/coffee-promo-mb-fr.b2339439.mp4";